<template>
  <v-menu
    :close-on-content-click="false"
    left
    offset-x
    nudge-left="10"
    v-model="show"
    max-height="80%"
    :close-on-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-list-item @click="show = !show" :ripple="false" :class="{ 'v-list-item--active': show }">
        <v-list-item-icon>
          <v-badge :content="noteCards.length" :value="noteCards.length" color="grey" bottom overlap>
            <v-icon>edit</v-icon>
          </v-badge>
        </v-list-item-icon>
      </v-list-item>
    </template>

    <v-card width="550px" class="resourceNoteCard">
      <v-btn
        style="position: absolute; top: 3px; right: 3px;"
        elevation="0"
        fab
        x-small
        @click="show = false"
      >
        <v-icon>close</v-icon>
      </v-btn>
      <v-card-title>
        Note Cards
      </v-card-title>
      <v-divider></v-divider>
      <template dense v-if="selected == false">
        <v-card-text>
          <v-list v-if="noteCards.length">
            <v-list-item
              v-for="noteCard in noteCards"
              :key="noteCard.id"
              @click="selected = noteCard.id"
              two-line
            >
              <v-list-item-content>
                <v-list-item-title v-text="noteCard.content.title"></v-list-item-title>
                <v-list-item-subtitle
                  v-html="
                    noteCard.content.text.slice(0, 90) +
                      `${noteCard.content.text.length > 90 ? '...' : ''}`
                  "
                ></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-subheader v-else>No Note Cards Yet</v-subheader>
        </v-card-text>
        <v-card-actions
          ><v-btn text color="primary" @click="selected = 'new'"
            >Add Note Card</v-btn
          ></v-card-actions
        >
      </template>
      <template v-else-if="selected == 'new'">
        <div
          class="grey--text text--darken-4 px-4 pt-4"
          style="font-size: 1.3em; word-break: initial;"
        >
          <content-editor
            v-model="newCardTitle"
            tabindex="0"
            ref="newCardTitle"
            :emitText="true"
            placeholder="Add a title"
            :hijackPaste="false"
            allowTraversal
            preventTab
          ></content-editor>
        </div>
        <v-card-subtitle class="grey--text text--darken-3 pb-8" style="font-size: 1em;">
          <content-editor
            v-model="newCardDescription"
            ref="newCardDescription"
            :emitText="false"
            placeholder="Add a Description"
            allowEnter
            allowFormats
            :hijackPaste="false"
            tabindex="1"
          ></content-editor>
        </v-card-subtitle>
        <!-- <v-row no-gutters class="px-4 pb-4">
          <v-btn small text>Attach Excerpts</v-btn>
        </v-row> -->
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text @click="cancelNew">Cancel</v-btn>
          <v-btn text class="primary" @click="createNote">Save</v-btn>
        </v-card-actions>
      </template>
      <template v-else-if="!!selected">
        <v-card-text class="px-2">
          <div
            class="grey--text text--darken-4 px-4 pt-4"
            style="font-size: 1.3em; word-break: initial;"
          >
            <content-editor
              v-model="selectedCardTitle"
              ref="cardTitle"
              :emitText="true"
              placeholder="Add a title"
              :hijackPaste="false"
              allowTraversal
              preventTab
            ></content-editor>
          </div>
          <v-card-subtitle class="grey--text text--darken-3 pb-8" style="font-size: 1em;">
            <content-editor
              v-model="selectedCardDescription"
              ref="cardDescription"
              :emitText="false"
              placeholder="Add a Description"
              allowEnter
              allowFormats
              allowTraversal
              :hijackPaste="false"
            ></content-editor>
          </v-card-subtitle>
        </v-card-text>
        <v-row no-gutters class="px-4 pb-4">
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
          <div class="caption grey--text">Referenced Excerpts</div>
          <v-spacer></v-spacer>
          <v-menu :close-on-content-click="false" left max-width="300px" max-height="90%">
            <template v-slot:activator="{ on: onMenu }">
              <v-btn v-on="onMenu" small text>Attach Excerpts</v-btn>
            </template>
            <excerpt-list
              ref="excerptList"
              :resource="resource"
              :userCanEdit="true"
              @select="toggleAddRemoveExcerpt"
            >
            </excerpt-list>
          </v-menu>
        </v-row>
        <v-row no-gutters>
          <v-list v-if="selectedCardExcerpts.length">
            <v-list-item
              v-for="excerpt in selectedCardExcerpts"
              :key="excerpt.id"
              @click="selectedExcerpt = excerpt.id"
              class="px-0"
              tabindex="-1"
            >
              <resource-card
                :flat="true"
                :disableHoverShadow="true"
                color="transparent"
                class="pa-4"
                :blockData="{ excerpts: [excerpt], resource: resource }"
                blockType="excerpt"
                style="width: 100%;"
              >
                <template v-slot:after>
                  <v-btn
                    v-if="userCanEdit && selectedExcerpt == excerpt.id"
                    @click.stop="toggleAddRemoveExcerpt(excerpt.id)"
                    text
                    small
                    class="float-right"
                    ><v-icon small>close</v-icon> Remove Excerpt</v-btn
                  >
                </template>
              </resource-card>
            </v-list-item>
          </v-list>
        </v-row>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text @click="selected = false">Back</v-btn>
          <v-spacer></v-spacer>
          <v-btn small text color="red">Delete Note</v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-menu>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ContentEditor from '@/components/ContentEditor';
import ResourceCard from '@/components/Resources/ResourceCard';
import ExcerptList from './ExcerptList';

export default {
  props: ['resource', 'value', 'userCanEdit'],
  components: { ContentEditor, ResourceCard, ExcerptList },
  data() {
    return {
      selected: false,
      selectedExcerpt: false,
      newCard: {
        title: '',
        description: ''
      }
    };
  },
  computed: {
    show: {
      get() {
        return this.value == 'notes';
      },
      set(v) {
        const val = v ? 'notes' : v;
        this.$emit('input', val);
      }
    },
    newCardTitle: {
      get() {
        return { html: this.newCard.title };
      },
      set(v) {
        this.newCard.title = v;
      }
    },
    newCardDescription: {
      get() {
        return { html: this.newCard.description };
      },
      set(v) {
        this.newCard.description = v;
      }
    },
    selectedCardTitle: {
      get() {
        return { html: this.selectedCard.content.title };
      },
      set(v) {
        this.updateNote({
          resourceId: this.resource.id,
          noteId: this.selected,
          update: { content: { title: v } }
        });
        console.log(v);
      }
    },
    selectedCardDescription: {
      get() {
        return { html: this.selectedCard.content.text };
      },
      set(v) {
        this.updateNote({
          resourceId: this.resource.id,
          noteId: this.selected,
          update: { content: { text: v } }
        });
      }
    },
    noteCards() {
      console.log(this.resource);
      //const types = ['note'];
      return Object.values(this.resource.noteBlocks).filter(n => {
        return !n.toDelete && n.type == 'note';
      });
    },
    selectedCard() {
      return this.selected && this.selected !== 'new'
        ? this.resource.noteBlocks[this.selected]
        : false;
    },
    selectedCardExcerpts() {
      if (!this.selected || this.selected == 'new') return [];

      const refNoteIds = this.selectedCard.content.refNotes;
      return refNoteIds.map(r => this.resource.noteBlocks[r]);
    }
  },
  methods: {
    ...mapActions('resources', ['updateResourceText', 'addNote', 'updateNote']),
    async createNote() {
      const newId = await this.addNote({
        resourceId: this.resource.id,
        title: this.newCard.title,
        text: this.newCard.description
      });
      this.selected = newId;
      this.newCard = {
        title: '',
        description: ''
      };
    },
    toggleAddRemoveExcerpt(id) {
      //  If note is already included, remove it, else add it to notes ref notes
      const currentRefNotes = this.selectedCard.content.refNotes || [];
      let refNotes;
      if (!currentRefNotes.includes(id)) {
        refNotes = [...currentRefNotes, id];
      } else {
        refNotes = currentRefNotes.filter(n => n != id);
      }
      this.updateNote({
        resourceId: this.resource.id,
        noteId: this.selected,
        update: { content: { refNotes } }
      });
    },
    cancelNew() {
      this.selected = false;
      this.newCard = {
        title: '',
        description: ''
      };
    }
  }
};
</script>

<style>
.resourceNoteCard .v-list-item p {
  margin-bottom: 0px;
}
</style>
